export const baseCharacterMap = {
  '°': 'deg',
  '÷': '/',
  '×': '*',
  'π': 'pi',
  'ln': 'log',
  'log': 'log10',
  '√': 'sqrt',
};

const getCharacterRegex = (map) => new RegExp(Object.keys(map).join('|'), 'ig');

const getCharacterReplacer = (map) => (match) => map[match] ?? match;

export const preprocessExpression = (expression, characterMap) => {
  const map = { ...baseCharacterMap, ...characterMap };

  return expression
    // first, get rid of any spaces between two digits
    // - those are inserted by Bing regardless of language/market
    .replace(/(\d)\s(\d)/, (match, d1, d2) => d1 + d2)
    .replace(
      getCharacterRegex(map),
      getCharacterReplacer(map),
    );
};

// Bing may include radians or degrees sign in the expression for clarity. We default to radians
// and math.js can't parse expressions like `sin(3 + e rad)` so it's best to
// simply strip this away.
export const preprocessInitialExpression = (initialExpression) => initialExpression.replace(/\sradians|°/, '');
